import { derived, writable } from "svelte/store";
import translations from "./translations";

export const locale = writable("ko");

// https://svelte.dev/repl/de39de663ef2445b8fe17b79c500013b?version=3.33.0
export function translate(
  lang: string,
  key: string,
  vars: { [key: string]: string }
) {
  let text = translations[lang]![key] || key;

  Object.keys(vars).map((k) => {
    const regex = new RegExp(`{{${k}}}`, "g");
    text = text.replace(regex, vars[k]!);
  });

  return text;
}

export const t = derived(
  locale,
  ($locale) =>
    (key: string, vars = {}) =>
      translate($locale, key, vars)
);
